define('home/views/ChannelPromotionDiscussionView',[
    'backbone-marionette',

    'home/mixins/withTruncate',

    'home/templates/channelPromotionDiscussion',
], function (
    Marionette,

    withTruncate,

    channelPromotionDiscussionTemplate
) {
    'use strict';

    /**
     * A single thread shown on a channel promotion card. Shows the title,
     * comment count, and a couple of the first lines of the thread.
     *
     * Expects an Activity model that has a related Thread model.
     */
    var ChannelPromotionDiscussionView = Marionette.ItemView.extend({
        template: channelPromotionDiscussionTemplate,
        templateHelpers: function () {
            return {
                discussionRoute: this.model.thread.getDiscussionRoute(),
            };
        },
    });

    withTruncate.call(ChannelPromotionDiscussionView.prototype);

    return ChannelPromotionDiscussionView;
});

